import { inject } from '@angular/core';
import { CarouselName, PublicRoutes } from '../enums';
import { AppStateService, ItemService, UiService } from '../services';
import { ItemForDisplay } from '../models';

/** when extending this class be sure to implement ngOnInit */
export abstract class NgxAimHomeClass {
  // ngOnInit() {
  //   this.init();
  // }

  uiService = inject(UiService);
  appState = inject(AppStateService);
  itemService = inject(ItemService);
  routes = PublicRoutes;
  isMobile$ = this.uiService.isMobile$;
  carouselName = CarouselName.MAIN;
  locations = this.appState.getLocations();
  featuredItems: ItemForDisplay[] = [];

  init() {
    this.itemService.getFeaturedItems().subscribe({
      next: (items) => this.featuredItems = items,
      error: (err) => console.log(err),
    });
  }
}